import { EventListener } from "silver";

function getOffsetParents(start: Node|null): HTMLElement[] {
	const out: HTMLElement[] = [];
	let node:Node|null = start;
	while (node instanceof HTMLElement) {
		out.push(node);
		node = node.offsetParent;
	}
	return out;
}

export class StickyElementPosition {

	public readonly onParentNodeScroll = EventListener.create<{ sender: StickyElementPosition }>("parentNodeScroll");

	public isInFixedViewport: boolean = false;
	public documentTop: number = 0;
	public documentLeft: number = 0;
	public documentBottom: number = 0;
	public documentRight: number = 0;
	public width: number = 0;
	public height: number = 0;
	public containerDocumentBottom: number = 0;
	private stickyTop: number = 0;
	private unbinds: Array<() => void> = [];

	public constructor(element: HTMLElement, stickyTop: number) {
		this.recalculate(element, stickyTop);
	}

	public recalculate(element: HTMLElement, stickyTop: number) {
		this.unset();
		this.stickyTop = stickyTop;
		const offsetParents = getOffsetParents(element.parentNode);
		this.isInFixedViewport = offsetParents.reduce<boolean>((fixed, el) => {
			return fixed || getComputedStyle(el).position == "fixed";
		}, false);

		const doScroll = () => this.onParentNodeScroll.trigger({ sender: this });
		offsetParents.forEach(el => {
			el.addEventListener("scroll", doScroll);
			this.unbinds.push(() => el.removeEventListener("scroll", doScroll));
		});

		const container = (element.offsetParent || document.body);
		this.containerDocumentBottom = container.getBoundingClientRect().top + container.scrollHeight + (this.isInFixedViewport ? 0: window.scrollY);

		const rect = element.getBoundingClientRect();
		this.height = rect.height
		this.width = rect.width;
		this.documentTop = rect.top + (this.isInFixedViewport ? 0 : window.scrollY);
		this.documentBottom = this.documentTop + this.height;
		this.documentLeft = rect.left + (this.isInFixedViewport ? 0 : window.scrollX);
		this.documentRight = this.documentLeft + this.width;
	}

	public unset(): void {
		this.unbinds.forEach(u => u());
		this.unbinds = [];
	}

	public get containerScrollY(): number {
		return this.isInFixedViewport ? 0 : window.scrollY;
	}

	public get containerScrollX(): number {
		return this.isInFixedViewport ? 0 : window.scrollX;
	}

	public get viewportTop(): number {
		return this.documentTop - this.containerScrollY;
	}

	public get viewportLeft(): number {
		return this.documentLeft - this.containerScrollX;
	}

	public get viewportBottom(): number {
		return this.documentBottom - this.containerScrollY;
	}

	public get viewportRight(): number {
		return this.documentRight - this.containerScrollX;
	}

	public topIsAboveViewport(): boolean {
		return this.viewportTop < this.stickyTop;
	}

	public bottomIsAboveViewport(): boolean {
		return this.height > (this.containerDocumentBottom - this.containerScrollY);
	}
}
